module.exports = __webpack_public_path__ + "static/img/user_1.cd68203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_1.png
// module id = Qzqd
// module chunks = 0